import type { SectionTab } from 'v2/shared/components/section-tabs'
import type { EnterpriseRequestSource } from 'v2/shared/utils/buddy-enterprise-request'

export type AlertingTab = 'voice' | 'messages' | 'balance-alerts'

export const ALERTING_TAB_COPY: Record<AlertingTab, SectionTab> = {
  voice: { title: 'Voice alerts', description: 'Monitor call issues and voice alert policies.' },
  messages: {
    title: 'Message alerts',
    description: 'Monitor messaging issues and alert policies.',
  },
  'balance-alerts': {
    title: 'Balance alerts',
    description: 'Manage alerts for your organization’s prepaid balance.',
  },
}

/** Message alerts are Enterprise-gated: below Enterprise they open the Buddy upgrade request. */
export const alertingTabLockSource = (
  tab: AlertingTab,
  isEnterpriseLocked: boolean,
): EnterpriseRequestSource | undefined =>
  tab === 'messages' && isEnterpriseLocked ? 'messaging' : undefined

// Postpaid accounts have no balance alerts; `=== false` keeps the tab hidden while loading.
export const hasBalanceAlerts = (isPostpaid: boolean | undefined) => isPostpaid === false
